import { archivalSearchApi } from "../../../api/apiClient";
import { bankSettingsApi } from "../../../api/apiClient";

//SWIFT DAY
function getCorzapMessages(data) {
  return archivalSearchApi.post(`/archival/corzap-search`, data);
}

function sendMail(data) {
  return archivalSearchApi.post(`/archival/email`, data);
}

function getBankLogoURL() {
  return bankSettingsApi.get(`/bank/config/logo`);
}

export const swiftDayServices = {
  getCorzapMessages,
  sendMail,
  getBankLogoURL,
};
